<template>
  <div>
    <form id="form_sala">
        <router-link :to="{name: 'listagem-salas'}" href="#">
          <button class="btn btn-primary btn-micro" id="btn" type="button">
            <i class="fa fa-arrow-left"></i>
          </button>
        </router-link>
        <div class="row justify-content-center">
            <div class="col-md-6">
              <InputIconGroup typeInput="text" idInput="sala" iconInput="fa-info" labelInput="Sala"></InputIconGroup>
            </div>
            <div class="col-md-6">
              <InputIconGroup typeInput="number" idInput="capacidade" iconInput="fa-info" labelInput="Capacidade" min="0"></InputIconGroup>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center">
                <button class="btn btn-secondary" id="btn_limpar" type="reset">Limpar</button>&nbsp;&nbsp;
                <button class="btn btn-primary" id="btn_salvar" type="submit" @click="salvaInformacoes">Salvar</button>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
import SalasController from './SalasController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'

export default {
  name: 'form-sala',
  components: {
    InputIconGroup,
    DateIconGroup
  },
  data () {
    return {
      content: {
        load: true
      }
    }
  },
  mounted () {
    if (this.$route.params.idSala) {
      SalasController.carregaFormularioDeEdicao(this.$route.params.idSala)
    }
  },
  methods: {
    salvaInformacoes () {
      if (this.$route.params.idSala) {
        SalasController.update(this.$route.params.idSala)
      } else {
        SalasController.store()
      }
    }
  }
}
</script>
